import { Injectable } from '@angular/core';
import {
	ActivatedRouteSnapshot,
	CanActivate,
	Router,
	RouterStateSnapshot,
} from '@angular/router';

import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { ErrorService } from '../services/error.service';
/**
 * Guard d'autorisation d'accès à l'application. Stocke le token dans localStorage sous le bom 'apiToken'.
 */
@Injectable()
export class AuthGuard implements CanActivate {
	constructor(
		private router: Router,
		private authService: AuthService,
		private errorService: ErrorService
	) {}

	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean> {
		return this.authService.connexion().pipe(
			map((r) => r),
			catchError((error) => {
				this.errorService.setError(500, 'Connexion impossible');
				this.router.navigate(['/error']);
				return of(false);
			})
		);
	}
}
